import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { Link as RouterLink, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

/**
 * Public landing page shown to unauthenticated visitors at `/`. Renders a
 * "what is this" pitch and a single Login button — no app chrome, no menu.
 *
 * If a deep link to a protected route was attempted, `ProtectedRoute` bounced
 * the user here with the original `location` in `state.from`. We forward that
 * to the login form so a successful sign-in returns the user to where they
 * meant to go.
 *
 * Already-signed-in users bypass this page entirely → /home.
 */
export function HoldingPage() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (token) return <Navigate to="/home" replace />;

  const from = (location.state as { from?: { pathname?: string } } | null)?.from;

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'background.default' }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={2}>
              <Typography variant="h4" sx={{ fontWeight: 700 }}>Template.NET</Typography>
              <Typography variant="body1" color="text.secondary">
                Reference template for Azure migration projects — ASP.NET Core 10 + React,
                Container Apps, SQL Server, granular role/group authorisation.
              </Typography>
              <Box sx={{ pt: 1 }}>
                <Button
                  component={RouterLink}
                  to="/login"
                  state={from ? { from } : undefined}
                  variant="contained"
                  size="large"
                  startIcon={<LoginIcon />}
                >
                  Sign in
                </Button>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
